import { Form, Select } from 'antd';
import React, { FC, ReactElement, useEffect, useRef, useState } from 'react';
import { useForm } from 'antd/es/form/Form';
import { useDivisionsQuery } from 'app/services/edpApiV1/viewer';
import { ISearchData } from 'shared/types/rvd.types';
import style from './index.module.scss';
import Fio from './form-items/fio/Fio';
import PersonnelNumber from './form-items/personnelNumber/PersonnelNumber';
import DateSearch from './form-items/date/DateSearch';
import IdSearch from './form-items/id/IdSearch';
import PositionName from './form-items/positionName/PositionName';

export type TInputProps = {
  onSearch: (data: ISearchData) => void;
};

enum FormValues {
  DIVISION = 'divisionId',
  SELECT_OPTIONS = 'selectOptions',
}

export enum SelectOptions {
  FIO_OPTION = 'fio',
  PN_OPTION = 'personnelNumber',
  DATE_OPTION = 'date',
  ID_OPTION = 'byId',
  POSITION_NAME = 'positionName',
}
const initialValues = {
  selectOptions: SelectOptions.FIO_OPTION,
};

const SearchComponent: FC<TInputProps> = ({ onSearch }) => {
  const [form] = useForm();
  const [optionsSearch, setOptionsSearch] = useState<SelectOptions>(SelectOptions.FIO_OPTION);

  const { data: divisions } = useDivisionsQuery(null);

  const searchData = useRef<ISearchData>({ divisionId: '' });

  const onFormFieldChange = (data: string, key: keyof ISearchData) => {
    Object.values(SelectOptions).forEach(val => {
      if (val !== key) {
        searchData.current[val] = '';
      }
    });
    searchData.current[key] = data;
    searchData.current.divisionId = form.getFieldValue(FormValues.DIVISION);
    onSearch(searchData.current);
  };

  const [currentSearchInput, setCurrentSearchInput] = useState<ReactElement | null>(
    Fio({ onSearch: onFormFieldChange }),
  );

  useEffect(() => {
    if (optionsSearch === SelectOptions.FIO_OPTION) {
      setCurrentSearchInput(Fio({ onSearch: onFormFieldChange }));
    } else if (optionsSearch === SelectOptions.DATE_OPTION) {
      setCurrentSearchInput(DateSearch({ onSearch: onFormFieldChange }));
    } else if (optionsSearch === SelectOptions.PN_OPTION) {
      setCurrentSearchInput(PersonnelNumber({ onSearch: onFormFieldChange }));
    } else if (optionsSearch === SelectOptions.ID_OPTION) {
      setCurrentSearchInput(IdSearch({ onSearch: onFormFieldChange }));
    } else if (optionsSearch === SelectOptions.POSITION_NAME) {
      setCurrentSearchInput(PositionName({ onSearch: onFormFieldChange }));
    }
  }, [optionsSearch]);

  const onSelectDivisionId = () => {
    form.setFieldValue(SelectOptions.FIO_OPTION, '');
  };

  const onClear = () => {};

  const onSelectOptionsSearch = (value: SelectOptions) => {
    setOptionsSearch(value);
  };

  return (
    <Form form={form} className={style.searchWrap} initialValues={initialValues}>
      <Form.Item name={FormValues.DIVISION}>
        <Select
          placeholder="Выберите подразделение"
          className={style.selectDivisions}
          onSelect={onSelectDivisionId}
          allowClear={true}
          onClear={onClear}
        >
          {divisions?.data?.map(({ id, name }) => (
            <Select.Option key={id} value={id}>
              {name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name={FormValues.SELECT_OPTIONS}>
        <Select placeholder="Параметры поиска" className={style.selectDivisions} onSelect={onSelectOptionsSearch}>
          <Select.Option key={SelectOptions.FIO_OPTION} value={SelectOptions.FIO_OPTION}>
            Поиск по ФИО
          </Select.Option>
          <Select.Option key={SelectOptions.PN_OPTION} value={SelectOptions.PN_OPTION}>
            Поиск по табельному №
          </Select.Option>
          <Select.Option key={SelectOptions.DATE_OPTION} value={SelectOptions.DATE_OPTION}>
            Поиск по дате работ
          </Select.Option>
          <Select.Option key={SelectOptions.ID_OPTION} value={SelectOptions.ID_OPTION}>
            Поиск по номеру заявки
          </Select.Option>
          <Select.Option key={SelectOptions.POSITION_NAME} value={SelectOptions.POSITION_NAME}>
            Поиск по должности
          </Select.Option>
        </Select>
      </Form.Item>
      {currentSearchInput}
    </Form>
  );
};

export default SearchComponent;
